import { infoFetchGetTituloI, makeTitulo } from "dtos/titulo";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";
import { infoFetchGetModalidadI, makeModalidad } from "dtos/modalidad";

export const getModalidadPaginado = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetModalidadI>
  >({
    method: "GET",
    uri: ENDPOINTS.MODALIDAD_PAGINADO,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeModalidad(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const getModalidades = async (params: any) => {
  const response = await sendRequest<infoFetchGetModalidadI[]>({
    method: "GET",
    uri: ENDPOINTS.MODALIDAD,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  // return elementos.map((ct) => makeNivel(ct));

  const elementosFormated = response.map((ctElemento) =>
    makeModalidad(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postModalidad = async ({ params }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetModalidadI>({
    method: "POST",
    uri: ENDPOINTS.MODALIDAD,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeModalidad(response);
};

export const putModalidad = async ({ params }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetModalidadI>({
    method: "PUT",
    uri: ENDPOINTS.MODALIDAD,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeModalidad(response);
};

export const deleteModalidad = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.MODALIDAD + "/" + id,
  });
  return response;
};
